module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [(_vm.FormInputs.IndividualLabels || _vm.FormInputs.BusinessLabels) ? _c('div', [_vm._v("\n          Association Information and Communication Preferences\n        ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('div', [_vm._v("Communication Preferences")]) : _vm._e()])]), _vm._v(" "), (
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', [_vm._v(" Please select all of your professional affiliations. ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.CheckboxBusiness), function(value, key, index) {
    return (_vm.FormInputs.BusinessOrganization) ? _c('div', {
      key: index,
      staticClass: "col-lg-6 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n              " + _vm._s(key) + "\n            ")])])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.CheckboxIndividual), function(value, key) {
    return (_vm.FormInputs.IndividualOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(key) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.Account.Organizations.List.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n          Please enter any other professional organizations you are associated\n          with separated by semicolon(;).\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Organizations.Others),
      expression: "Account.Organizations.Others"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.Organizations.Others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.Organizations, "Others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [(
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('label', {
    staticClass: "label-heading"
  }, [_vm._v("\n        Communication Preferences\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bot"
  }, [_vm._v("Please confirm communication preferences.")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToBeContactedAsVolunteer),
      expression: "Account.ToBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToBeContactedAsVolunteer) ? _vm._i(_vm.Account.ToBeContactedAsVolunteer, null) > -1 : (_vm.Account.ToBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like to be contacted if there are volunteer opportunities in\n          my area.\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToReceiveNewsLetter),
      expression: "Account.ToReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToReceiveNewsLetter) ? _vm._i(_vm.Account.ToReceiveNewsLetter, null) > -1 : (_vm.Account.ToReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like email updates from OneSight EssilorLuxottica Foundation.\n        ")])])])]), _vm._v(" "), (_vm.Account.Organizations.List.includes('Team Vision')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Addendum),
      expression: "Account.Addendum"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.Addendum) ? _vm._i(_vm.Account.Addendum, "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.") > -1 : (_vm.Account.Addendum)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.Addendum,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "Addendum", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "Addendum", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "Addendum", $$c)
        }
      }
    }
  }), _vm._v("\n          Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Addendum),
      expression: "Account.Addendum"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.Addendum) ? _vm._i(_vm.Account.Addendum, "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.") > -1 : (_vm.Account.Addendum)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.Addendum,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "Addendum", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "Addendum", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "Addendum", $$c)
        }
      }
    }
  }), _vm._v("\n          Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("Team Vision Addendum *")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b2f0fac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2f0fac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/AssociationAndCommunication.vue
// module id = 504
// module chunks = 4